import axiosInstance from '../auth/FetchInterceptor'
import { AxiosResponse } from 'axios'

export type UploadRequest = {
  file: File,
  presignedS3UploadLink: string,
  abortSignal: AbortSignal,
}

export type UploadFileResponseData = void
export type UploadFileResponse = AxiosResponse<UploadFileResponseData>

export type AwsS3ServiceType = {
  uploadFileToS3: (request: UploadRequest) => Promise<UploadFileResponse>;
}

const AwsS3Service: AwsS3ServiceType = {
  uploadFileToS3: (request: UploadRequest) =>
    axiosInstance.put<UploadFileResponseData, UploadFileResponse, File>(
      request.presignedS3UploadLink,
      request.file,
      {
        signal: request.abortSignal,
      },
    ),
}

export default AwsS3Service